/**
 * "Take the 5-minute tour" — the empty board's first call to action.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap } from 'lucide-react';

import { Button } from '@/components/ui';

export const TourCta: FC = () => (
  <Button size="sm" asChild>
    <Link to={{ search: '?tab=tutorial' }}>
      <GraduationCap className="mr-1 h-3.5 w-3.5" /> Take the 5-minute tour
    </Link>
  </Button>
);
